import axios from 'axios'
import config from '../config'
import { EventBus } from '@/event-bus.js'
// import router from '../router'
// import * as Routes from '../constants/routes'

export default {
  request (method, uri, data = null) {
    return new Promise(function (resolve, reject) {
      data.token = window.localStorage.getItem('token')
      let error
      if (!method) {
        error = new Error('API function call requires method argument')
        reject(error)
      }
      if (!uri) {
        error = new Error('API function call requires uri argument')
        reject(error)
      }

      let url = `${window.location.protocol}//${window.location.host}/v1.0/` + uri

      axios({ method, url, data }).then(response => {
        if (response.data.error) {
          switch (response.data.error) {
            case 0:
              EventBus.$emit('TOKEN is not present')
              break
            case 52:
              EventBus.$emit('TOKEN is not valid')
              break
            case 61:
              EventBus.$emit('invalid-token')
              break
            case 67:
              // this.response = 'Code not recognised, please try again'
              break
            case 45:
              EventBus.$emit('invalid-login') // 'Oops! The details you\'ve entered aren\'t valid. ]Please try again.'
              break
            case 209:
              // this.response = 'Username or Password not correctly Formatted'
              break
            case 59:
              // this.response = 'No user access'
              break
            default:
              break
          }
          var error = {
            error: response.data.error,
            message: response.data.description || response.data.errorMessage
          }
          reject(error)
          // router.push(Routes.LOGIN)
        } else {
          resolve(response)
        }
      })
    })
  }, 
  async mock (uri) {
    const res = await axios.post(`https://qa-ubuntu.leak.bot/v1.0/${uri}`);
    return res
  }
}
